export default __webpack_public_path__ + "static/media/d_faq.1796cbc3.png";